import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { SvgLineSplit, SecondaryBtn } from '@tmapy/style-guide';
import { actionActivateSplitLineTool, actionDeactivateTools } from '../actions';
export const SplitLineToolBtn = ({ isActive, dispatch, children, }) => {
    const handleClick = useCallback(() => {
        if (isActive) {
            dispatch(actionDeactivateTools());
        }
        else {
            dispatch(actionActivateSplitLineTool());
        }
    }, [dispatch, isActive]);
    return (_jsx(SecondaryBtn, { icon: { element: _jsx(SvgLineSplit, {}) }, isActive: isActive, tooltip: children, onClick: handleClick }));
};
//# sourceMappingURL=SplitLineToolBtn.js.map